import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import { Observable, of } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
    tap
} from "rxjs/operators";
import { AnvandareDTO } from "~app/common/models/anvandare/AnvandareDTO";
import { TypeAheadDTO } from "~app/common/models/common/TypeAheadDTO";
import { ModelActionService } from "~app/common/services/cqs/model-action.service";
import { LeverantorService } from "../../leverantor.service";

@Component({
    selector: "rask-redigera-intressent",
    styleUrls: ["./redigera-intressent.component.scss"],
    templateUrl: "./redigera-intressent.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        NgbTypeahead
    ]
})
export class RedigeraIntressentComponent implements OnInit {
    @Output() added = new EventEmitter<AnvandareDTO>();
    @Input() disabled: boolean;
    intressenter: AnvandareDTO[];
    @Output() removed = new EventEmitter<AnvandareDTO>();
    searchFailed: boolean;

    // form: FormGroup;
    searchString: any;
    searching: boolean;

    private readonly leverantorService = inject(LeverantorService);
    private readonly modelActionService = inject(ModelActionService);

    @Input() set leverantorid(val) {
        this.loadIntressenter(val);
    }

    canRemove() {
        return !this.disabled;
    }

    inputFormat(value: any) {
        return value.efternamn !== undefined ? `${value.fornamn} ${value.efternamn}` : value;
    }

    loadIntressenter(id: number) {
        if (id) {
            this.leverantorService.getIntressenter(id).subscribe(result => {
                this.setIntressenter(result);
            });
        } else {
            this.setIntressenter([]);
        }
    }

    ngOnInit() {
        this.searchString = "";
    }

    remove(intressent: AnvandareDTO) {
        const i = this.intressenter.indexOf(intressent);
        this.intressenter.splice(i, 1);
        this.removed.emit(intressent);
    }

    resultFormat(value: TypeAheadDTO) {
        return value.namn;
    }

    searchAnvandare(searchtext: string): Observable<TypeAheadDTO[]> {
        if (searchtext.length > 2) {
            return this.leverantorService.searchAnvandare(searchtext).pipe(
                catchError(() => of([]))
            );
        } else {
            return of([]);
        }
    }

    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(term => this.searchAnvandare(term)),
            tap(() => this.searching = false)
        );

    selectItem(event: any) {
        this.intressenter.push(this.toAnvandareDTO(event.item));
        this.added.emit(event.item);
        event.preventDefault();
        this.searchString = "";
    }

    setIntressenter(intressenter: AnvandareDTO[]) {
        this.intressenter = intressenter;
        this.modelActionService.bindModel(this.intressenter, "Intressent", "id");
    }

    toAnvandareDTO(typeahead: TypeAheadDTO): AnvandareDTO {
        return {
            fornamn: typeahead.namn,
            efternamn: "",
            id: typeahead.id
        } as AnvandareDTO;
    }
}
